import React, { useState, useEffect } from "react";
import styles from "./PlanATripProcessMain.module.css";

import { connect } from "react-redux";
import changeDetails from "../../../store/Actions/DetailsAction";

import { Link, useHistory } from "react-router-dom";

import moment from "moment";

import Select, { components } from "react-select";
import { AiFillCaretDown } from "react-icons/ai";
import Radio from "@material-ui/core/Radio";



function PlanATripProcessMain(props) {
  const country = props.details.country;
  const country_id = props.details.country_id;
  const persons = props.details.persons;
  const visa_type = props.details.visa_type;
  const visa_id = props.details.visa_id;
  const embassy_fees = props.details.embassy_fees;
  const normal_fees = props.details.normal_fees;
  const express_fees = props.details.express_fees;
  const stay_duration = props.details.stay_duration;
  const persons_details = props.details.persons_details;
  const date1 = moment(new Date(props.details.travel_date));
  const travel_date = date1.format("DD/MM/YYYY");
  const date2 = moment(new Date(props.details.return_date));
  const return_date = date2.format("DD/MM/YYYY");

  const travel_date1 = date1.toISOString();
  const return_date1 = date2.toISOString();

  const options = [{ value: "30 days single entry", label: "30 days single entry" }]

  const [entry,setEntry] = useState([]);

  const [id, setId] = useState("");
  const [token, setToken] = useState("");

  const history = useHistory();

  const [service, setService] = useState("normal");
  const [fees, setFees] = useState(0);
  const [total, setTotal] = useState(0)

  console.log(props.details);

  if (props.details.total === 0) {
    history.push("/dashboard/plan-a-trip");
  }

  const style1 = {
    control: (base) => ({
      ...base,
      border: "0 !important",
      boxShadow: "0 !important",
      fontSize: "16px",
      fontFamily: "Montserra",
      fontWeight: 400,
      lineHeight: "20px",
      cursor: "pointer",
      height: "60px",
      borderRadius: "10px",
      "&:hover": {
        border: "0 !important",
      },
    }),
    menu: (base) => ({
      ...base,
      marginTop: 2,
      fontSize: 16,
      maxWidth: 341,
    }),
    dropdownIndicator: (defaultStyles) => ({
      ...defaultStyles,
      color: "#7FA2B6",
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      transform: state.selectProps.menuIsOpen && "rotate(180deg)",
      color: "#7FA2B6",
      "&:hover": {
        color: "#7FA2B6",
      },
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isDisabled ? "#ffffff" : isFocused ? "#E7E7E7" : null,
        color: "#20313B",
        cursor: isDisabled ? "not-allowed" : "default",
      };
    },
  };
  const DropdownIndicator = (
    props: ElementConfig<typeof components.DropdownIndicator>
  ) => {
    return (
      <components.DropdownIndicator {...props}>
        <AiFillCaretDown size={20} color="#915713" />
      </components.DropdownIndicator>
    );
  };

  const handleService = (serv,amount) =>{
    setService(serv)
    setFees(amount)

    setTotal(persons * (amount + embassy_fees));
  }
  useEffect(()=>{
    handleService("normal",normal_fees)
  },[])

  const payOnline = () =>{
    const allInfo = {
      country: country,
      country_id: country_id,
      visa_type: visa_type,
      visa_id: visa_id,
      stay_duration: stay_duration,
      travel_date: travel_date1,
      return_date: return_date1,
      persons: persons,
      persons_details: persons_details,
      embassy_fees: embassy_fees*persons,
      service_fees: fees*persons,
      service: service,
      total: total, 
      normal_fees : normal_fees,
      express_fees : express_fees
    }
    props.ChangeDetails(allInfo)
    history.push('/dashboard/plan-a-trip/payment')
  }
  return (
    <div>
      <h2 className={styles.head}>Select processing time</h2>
      <div className={styles.boxTop}>
        <div className={styles.eachBox}>
          <div>
            <h2 className={styles.boxHead}>Destination</h2>
            <h2 className={styles.boxPera}>{country}</h2>
          </div>
        </div>

        <span className={styles.line}></span>

        <div className={styles.eachBox}>
          <div>
            <h2 className={styles.boxHead}>Visa type</h2>
            <h2 className={styles.boxPera}>30 days single entry</h2>
          </div>
        </div>
        <span className={styles.line}></span>

        <div className={styles.eachBox}>
          <div>
            <h2 className={styles.boxHead}>Departure</h2>
            <h2 className={styles.boxPera}>{travel_date}</h2>
          </div>
        </div>
        <span className={styles.line}></span>

        <div className={styles.eachBox}>
          <div>
            <h2 className={styles.boxHead}>Return</h2>
            <h2 className={styles.boxPera}>{return_date}</h2>
          </div>
        </div>
        <span className={styles.line}></span>

        <div className={styles.eachBox}>
          <div>
            <h2 className={styles.boxHead}>Travellers</h2>
            <h2 className={styles.boxPera}>{persons}</h2>
          </div>
        </div>
      </div>
      <div className={styles.mainBox}>
        <div className={styles.box1FirstCont}>
          <p className={styles.badge}>2 of 5</p>
          <p className={styles.FirstText}>Select Service type</p>
        </div>
        <div className={styles.twoBoxes}>
          <div className={styles.firstBox}>
          <div className={styles.select}>
                <Select
                  styles={style1}
                  className={styles.inners}
                  isSearchable={false}
                  options={options}
                  value={entry}
                  placeholder={"30 days single entry"}
                  onChange={(e) => {
                    setEntry([e]);
                  }}
                  components={{
                    IndicatorSeparator: () => null,
                    DropdownIndicator,
                  }}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      neutral50: "#000000",
                    },
                  })}
                />
              </div>
              <h2 className={styles.firstBoxHead}>Validity 59 Days</h2>
              <div>
              <p className={styles.requirementDes}>
                <span className={styles.mark}></span>
                <span className={styles.req}>
                You can enter {country} once and stay for maximum 30 days from your first date of entry.
                </span>
              </p>

              <p className={styles.requirementDes}>
                <span className={styles.mark}></span>
                <span className={styles.req}>
                You have to enter within 59 days from your date of visa approval.
                </span>
              </p>
              </div>
              <div className={styles.selectTypeBox}>

              <div
                className={styles.detailsBack}
                style={
                  service === "normal" ? { background: "linear-gradient(95.96deg, #F3AD5B 0%, #AA5606 103.16%)"} : null
                }
                onClick={() => {
                  handleService("normal", normal_fees);
                }}
              >
                <div className={styles.in}>
                  <Radio
                    style={
                      service === "normal" ? {color: "#ffffff"} : {color: "#D1E1EA"}
                    }
                    onChange={() => {
                      handleService("normal", normal_fees);
                    }}
                    checked={service === "normal"}
                    value="normal"
                    color="default"
                    name="service"
                  />
                  <div>
                    <h1 className={(service === "normal")? (styles.detailsHeadingActive): (styles.detailsHeading)}>Normal</h1>
                    <p className={(service === "normal")? (styles.detailsDesActive): (styles.detailsDes)}>Visa Processing Takes 5-8 Working Days</p>
                  </div>
                </div>

                <div>
                  <h1 className={(service === "normal")? (styles.detailsHeadingActive): (styles.detailsHeading)}>NGN {normal_fees.toLocaleString()}</h1>
                  {/* <p className={(service === "normal")? (styles.detailsDesActive): (styles.detailsDes)}>&nbsp;</p> */}
                </div>
              </div>
              <div
                className={styles.detailsBack}
                style={
                  service === "express" ? { background: "linear-gradient(95.96deg, #F3AD5B 0%, #AA5606 103.16%)"} : null
                }
                onClick={() => {
                  handleService("express", express_fees);
                }}
              >
                <div className={styles.in}>
                  <Radio
                   style={
                    service === "express" ? {color: "#ffffff"} : {color: "#D1E1EA"}
                  }
                    onChange={() => {
                      handleService("express", express_fees);
                    }}
                    checked={service === "express"}
                    value="express"
                    color="default"
                    name="service"
                  />
                  <div>
                    <h1 className={(service === "express")? (styles.detailsHeadingActive): (styles.detailsHeading)}>Express</h1>
                    <p className={(service === "express")? (styles.detailsDesActive): (styles.detailsDes)}>Visa Processing Takes 3-4 Working Days</p>
                  </div>
                </div>

                <div>
                  <h1 className={(service === "express")? (styles.detailsHeadingActive): (styles.detailsHeading)}>NGN {express_fees.toLocaleString()}</h1>
                  {/* <p className={(service === "express")? (styles.detailsDesActive): (styles.detailsDes)}>&nbsp;</p> */}
                </div>
              </div>

              <div className={styles.detailsLast2}>
                <div>
                  <h1 className={styles.detailsHeading}>Embassy Visa Fee</h1>
                  <p className={styles.detailsDes}>(Fees paid to embassy)</p>
                </div>
                <div>
                  <h1 className={styles.detailsHeading}>₦ {embassy_fees.toLocaleString()}</h1>
                  <p className={styles.detailsDes}>per applicant</p>
                </div>
              </div>

              </div>
          </div>
          <div className={styles.secondBox}>
            <hr className={styles.line2} />
          </div>
          <div className={styles.thirdBox}>
            <h3 className={styles.thirdHead}>Visa requirements</h3>
            <h4 className={styles.thirdHead2}>Passport Front</h4>
            <p className={styles.requirementDes2}>
                <span className={styles.mark}></span>
                <span className={styles.req2}>
                Upload colored passport copies.
                </span>
              </p>
              <p className={styles.requirementDes2}>
                <span className={styles.mark}></span>
                <span className={styles.req2}>
                Passport should be valid 6 months from the date of entry in {country}.
                </span>
              </p>
              <br />
            <h4 className={styles.thirdHead2}>Passport Back</h4>
            <p className={styles.requirementDes2}>
                <span className={styles.mark}></span>
                <span className={styles.req2}>
                Upload colored passport copy.
                </span>
              </p>
              <br />
            <h4 className={styles.thirdHead2}>Photograph</h4>
            <p className={styles.requirementDes2}>
                <span className={styles.mark}></span>
                <span className={styles.req2}>
                Upload photograph with white background.
                </span>
              </p>
              <br />
              <div className={styles.endBtns}>
                <button className={styles.endBtn} onClick={()=>payOnline()}>Pay Online</button>
                <Link to="/dashboard/faq">
                <button className={styles.endBtn2}>View FAQ's</button>
                </Link>
              </div>

          </div>

        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  details: state.Details.details,
});

const mapDispatchToProp = (dispatch) => ({
  ChangeDetails: (details) => dispatch(changeDetails(details)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProp
)(PlanATripProcessMain);
